import { render } from "./QueStem2.vue?vue&type=template&id=815fa2a8"
import script from "./QueStem2.vue?vue&type=script&lang=js"
export * from "./QueStem2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__